function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { StyledIcon, StyledText, StyledBadge } from './elements';
export const InnerBadge = ({
  position,
  size,
  overlap,
  variant,
  iconSrc,
  count,
  ...props
}) => {
  let childElement;
  if (size === 'hint') {
    childElement = /*#__PURE__*/React.createElement(React.Fragment, null);
  } else if (iconSrc) {
    childElement = /*#__PURE__*/React.createElement(StyledIcon, {
      $size: size,
      src: iconSrc
    });
  } else if (count) {
    childElement = /*#__PURE__*/React.createElement(StyledText, {
      $size: size
    }, count);
  }
  return /*#__PURE__*/React.createElement(StyledBadge, _extends({
    $position: position,
    $size: size,
    $overlap: overlap,
    $variant: variant,
    $hasIcon: !!iconSrc
  }, props), childElement);
};